module.exports = __webpack_public_path__ + "media/img/specialize/item1-6c400d6463ffb1b68e1b7cee25deda6f.svg";